import { createContext } from 'react';

const servicioContext = createContext();

export default servicioContext;
